export default "https://fenwan.cdn.bcebos.com/gamecenter/static/game/assets/imgs/official.f8dd9892.png";